import { Injectable, Optional, Inject, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SearchResult } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  #http = inject(HttpClient);
  #BASE_URL = inject(BASE_URL, { optional: true });

  search(q: string) {
    return this.#http.get<SearchResult[]>(`${this.#BASE_URL}api/search?q=${q}`);
  }

  SearchMagazine(q: string) {
    return this.#http.get<SearchResult[]>(`https://www.wisselstof.nl/api/articles/search?q=${q}`);
  }
}
